import styled from '@emotion/styled'
import { Grid } from '@mui/material'

export const Row = styled(Grid)`
  margin-bottom: 32px;
`
